var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { PureComponent, useEffect } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Redirect, Route, Switch, } from "react-router-dom";
import { LastLocationProvider } from "react-router-last-location";
import ResourceGuide from "./resourceGuide/index";
import AlertEmailPreview from "./emailPreview/alertEmailPreview";
import AchievementEmailPreview from "./emailPreview/achievementEmailPreview";
import CourseMultiSearchWrapper from "../src/View/Presentational/Course/CourseMultiSearch";
import FindScreen from "../src/View/Pages/VirtualizedApp/FindScreen";
import SurveyResponseDetails, { SURVEY_RESPONSE_BASE_PATH, } from "./survey/surveyResponseDetails";
import MeetingController from "./meeting/meetingController";
import AlertCoordinatorAdd from "./alert/alertCoordinatorAdd";
import AlertCoordinatorsList from "./alert/alertCoordinatorsList";
import AlertRuleAdd from "./alert/alertRuleAdd";
import AlertRulesList from "./alert/alertRulesList";
import EarlyAlertController from "./alert/earlyAlertController";
import OAuth from "./oauth/oauth";
import OAuthReceiver from "./oauth/oauthReceiver";
import { initApiClient } from "../services/AxiosClients";
import { getApiHostname } from "../util/windowLocationUtil";
import useReactRouter from "../src/View/Hooks/useReactRouter";
import AdvisorRoutes, { getAdvisorBasePath, getDashboardBasePath, } from "../src/View/Pages/Advisor/AdvisorRoutes";
import DashboardRoutes from "../src/View/Pages/Dashboard/DashboardRoutes";
import ReportRoutes, { getReportBasePath, } from "../src/View/Pages/Report/ReportRoutes";
import RosterRoutes, { getRosterBasePath, } from "../src/View/Pages/Roster/RosterRoutes";
import CourseSchedulerRoutes, { getCourseSchedulerBasePath, } from "../src/View/Pages/CourseScheduler/CourseSchedulerRoutes";
import MeetingRequestRoutes, { getMeetingBasePath, getMeetingRequestBaseRoute, } from "../src/View/Pages/MeetingRequest/MeetingRequestRoutes";
import "../src/View/Config";
import TaskRoutes, { getTaskBasePath } from "../src/View/Pages/Task/TaskRoutes";
import CampaignRoutes, { getCampaignBaseRoute, } from "../src/View/Pages/Campaign/CampaignRoutes";
import SEO, { SEOTitleContextProvider } from "../src/View/UI/SEO/SEO";
import VirtualizedAppRoutes from "../src/View/Pages/VirtualizedApp/VirtualizedAppRoutes";
import { getMessageBasePath } from "../src/View/Pages/Message/MessageRoutes/MessageRoutes";
import MessageLayout from "../src/View/Pages/Message/MessageLayout";
import { VirtualizedAppContextProvider, getVirtualizedAppName, } from "../src/View/Hooks/useVirtualizedApp";
import Handlers from "./PageChangeListeners";
import PipelineRoutes, { getPipelinesBaseRoute, } from "../src/View/Pages/Pipeline/PipelineRoutes";
import OpportunityRoutes, { getOpportunityBaseRoute, } from "../src/View/Pages/Opportunity/OpportunityRoutes";
import AdminRoutes, { getAdminBaseRoute, } from "../src/View/Pages/Admin/AdminRoutes";
import { FolderStateContextProvider } from "../src/View/Presentational/Folder/FolderStateContext";
import { NoticeContextProvider } from "../src/View/Hooks/useNotices";
import { InstitutionContextProvider } from "../src/View/Hooks/useInstitution";
import MeetingsRoutes, { getMeetingsBaseRoute, } from "../src/View/Pages/Meeting/MeetingsRoutes";
import VirtualizedAppDomainService from "../src/Domain/VirtualizedApp/VirtualizedApp.service";
// eslint-disable-next-line no-unused-vars
const TIMEOUT_MAX = 2147483647;
export const getPreBaseRoute = () => "/aviso/:virtualizedApp";
export const ID_VARIABLE = () => "/:id";
export const PERSON_TYPE_VARIABLE = () => "/:personType";
export const getDefaultRedirectBaseRoute = () => "/aviso/advise";
export const getPreBasePath = (virtualizedAppName) => {
    var _a;
    if (!virtualizedAppName) {
        virtualizedAppName =
            (_a = getVirtualizedAppName()) !== null && _a !== void 0 ? _a : VirtualizedAppDomainService.FIND_APP_NAME;
    }
    return "/aviso/" + virtualizedAppName;
};
// Old paths for redirects
const REPORT_OLD_PATH = "/aviso/app/report";
const DASHBOARD_OLD_PATH = "/aviso/app/dashboard";
const ROSTER_PAGE_OLD_PATH = "/aviso/app/roster";
const SURVEY_RESPONSE_OLD_PATH = "/aviso/app/surveyResponse/:id";
const MEETING_OLD_PATH = "/aviso/app/meeting";
const MEETING_REQUEST_OLD_PATH = "/aviso/app/meetingRequest";
const CAMPAIGN_OLD_PATH = "/aviso/app/campaign";
const APP_START_BASE_PATH = "/aviso/app/start";
const COURSE_SCHEDULER_OLD_PATH = "/aviso/app/courseScheduler";
const TASK_OLD_PATH = "/aviso/app/task";
const MESSAGE_OLD_PATH = "/aviso/app/messages";
const PrivateRoute = (_a) => {
    var { component, isAuthenticated } = _a, rest = __rest(_a, ["component", "isAuthenticated"]);
    const Component = component;
    return (
    // @ts-expect-error - TS2769 - No overload matches this call.
    _jsx(Route, Object.assign({}, rest, { render: (props) => {
            if (isAuthenticated) {
                return _jsx(Component, Object.assign({}, props));
            }
            // If they aren't authenticated, then we need to determine if they are in admin or the non-admin
            // side of the app, and set the redirect URL appropriately. This allows the Grails app to render
            // the correct layout when the user comes back to the app from the oauth redirect.
            let redirectPathName = "/aviso/app/oauth/sender";
            if (/\/app\/admin\//.test(props.location.pathname)) {
                redirectPathName = "/aviso/app/admin/oauth/sender";
            }
            return (_jsx(Redirect, { to: {
                    pathname: redirectPathName,
                    state: { from: props.location, search: props.location.search },
                } }));
        } })));
};
class Index extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            isAuthenticated: true,
        };
    }
    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
        initApiClient(`${window.location.protocol}//${getApiHostname()}/`, () => {
            this.setState({ isAuthenticated: false });
        });
    }
    render() {
        return (_jsxs(SEOTitleContextProvider, { children: [_jsx(SEO, {}), _jsxs(Switch, { children: [_jsx(Route, { component: OAuth, path: "/aviso/app/(admin/)?oauth/sender" }), _jsx(Route
                        // @ts-expect-error - TS7006 - Parameter 'props' implicitly has an 'any' type.
                        , { 
                            // @ts-expect-error - TS7006 - Parameter 'props' implicitly has an 'any' type.
                            component: (props) => {
                                return (_jsx(OAuthReceiver, Object.assign({}, props, { 
                                    // @ts-expect-error - TS2339 - Property 'onTokenReceived' does not exist on type 'Index'.
                                    onTokenReceived: this.onTokenReceived })));
                            }, path: "/aviso/app/(admin/)?oauth/receiver" }), _jsx(PrivateRoute, { path: "/aviso/find/", component: FindScreen, isAuthenticated: this.state.isAuthenticated }), _jsx(PrivateRoute, { path: "/aviso/:virtualizedApp/app/advisor/people/find", component: FindScreen, isAuthenticated: this.state.isAuthenticated }), _jsx(Route, { component: ResourceGuide, path: "/aviso/app/resourceGuide" }), _jsx(Route, { component: ResourceGuide, path: "/aviso/app/resources" }), _jsx(Redirect, { from: SURVEY_RESPONSE_OLD_PATH, to: getDefaultRedirectBaseRoute() +
                                SURVEY_RESPONSE_BASE_PATH() +
                                ID_VARIABLE() }), _jsx(PrivateRoute, { component: SurveyResponseDetails, path: getPreBaseRoute() + SURVEY_RESPONSE_BASE_PATH() + ID_VARIABLE(), isAuthenticated: this.state.isAuthenticated }), _jsx(Redirect, { from: MEETING_OLD_PATH, to: getDefaultRedirectBaseRoute() + getMeetingBasePath() }), _jsx(PrivateRoute, { component: MeetingController, path: getPreBaseRoute() + getMeetingBasePath(), isAuthenticated: this.state.isAuthenticated }), _jsx(Redirect, { from: COURSE_SCHEDULER_OLD_PATH, to: getDefaultRedirectBaseRoute() + getCourseSchedulerBasePath() }), _jsx(PrivateRoute, { component: CourseSchedulerRoutes, path: getPreBaseRoute() + getCourseSchedulerBasePath(), isAuthenticated: this.state.isAuthenticated }), _jsx(Redirect, { from: ROSTER_PAGE_OLD_PATH, to: getDefaultRedirectBaseRoute() + getRosterBasePath() }), _jsx(PrivateRoute, { component: RosterRoutes, path: getPreBaseRoute() + getRosterBasePath(), isAuthenticated: this.state.isAuthenticated }), _jsx(Redirect, { from: TASK_OLD_PATH, to: getDefaultRedirectBaseRoute() + getTaskBasePath() }), _jsx(PrivateRoute, { component: TaskRoutes, path: getPreBaseRoute() + getTaskBasePath(), isAuthenticated: this.state.isAuthenticated }), _jsx(PrivateRoute, { component: AdvisorRoutes, path: getPreBaseRoute() + getAdvisorBasePath(), isAuthenticated: this.state.isAuthenticated }), _jsx(Redirect, { from: DASHBOARD_OLD_PATH, to: getDefaultRedirectBaseRoute() + getDashboardBasePath() }), _jsx(PrivateRoute, { component: DashboardRoutes, path: getPreBaseRoute() + getDashboardBasePath(), isAuthenticated: this.state.isAuthenticated }), _jsx(Redirect, { from: REPORT_OLD_PATH, to: getDefaultRedirectBaseRoute() + getReportBasePath() }), _jsx(PrivateRoute, { component: ReportRoutes, path: getPreBaseRoute() + getReportBasePath(), isAuthenticated: this.state.isAuthenticated }), _jsx(Redirect, { from: MEETING_REQUEST_OLD_PATH, to: getDefaultRedirectBaseRoute() + getMeetingRequestBaseRoute() }), _jsx(PrivateRoute, { component: MeetingRequestRoutes, path: getPreBaseRoute() + getMeetingRequestBaseRoute(), isAuthenticated: this.state.isAuthenticated }), _jsx(Redirect, { from: CAMPAIGN_OLD_PATH, to: getDefaultRedirectBaseRoute() + getCampaignBaseRoute() }), _jsx(PrivateRoute, { component: CampaignRoutes, path: getPreBaseRoute() + getCampaignBaseRoute(), isAuthenticated: this.state.isAuthenticated }), _jsx(PrivateRoute, { component: VirtualizedAppRoutes, path: APP_START_BASE_PATH, isAuthenticated: this.state.isAuthenticated }), _jsx(Redirect, { from: MESSAGE_OLD_PATH, to: getDefaultRedirectBaseRoute() + getMessageBasePath() }), _jsx(PrivateRoute, { component: MessageLayout, path: getPreBaseRoute() + getMessageBasePath(), isAuthenticated: this.state.isAuthenticated }), _jsx(PrivateRoute, { component: PipelineRoutes, path: getPipelinesBaseRoute(), isAuthenticated: this.state.isAuthenticated }), _jsx(PrivateRoute, { isAuthenticated: this.state.isAuthenticated, path: getOpportunityBaseRoute(), component: OpportunityRoutes }), _jsx(PrivateRoute, { isAuthenticated: this.state.isAuthenticated, path: getMeetingsBaseRoute(), component: MeetingsRoutes }), _jsx(PrivateRoute, { component: AdminRoutes, path: getAdminBaseRoute(), isAuthenticated: this.state.isAuthenticated })] })] }));
    }
}
/*
This acts as a sort of "dummy" component - all we are trying to do here is detect when the
application changes routes. To do this, we have to use the useReactRouter hook, so we have to
have a funcitonal component, not a class component. We also need to have this component be
rendered *inside* a Router component (which comes from the React Router library). So we place
this component alone side the root Index component for the app, and then we use this to listen
for route changes and trigger the appropriate callback for the initiator of the app.
 */
const RouterListener = ({ onHistoryChange, }) => {
    const routerContext = useReactRouter();
    useEffect(() => {
        const unsubscribe = routerContext.history.listen((location) => {
            // Listen for when the route changes, and when it does, call the onHistoryChange function, passing the information about
            // the route location.
            if (onHistoryChange) {
                onHistoryChange(location);
            }
        });
        // The listener only fires when the location *changes* so we'll fire it manually for the first page load.
        if (onHistoryChange) {
            onHistoryChange(routerContext.location);
        }
        return unsubscribe;
    }, [onHistoryChange, routerContext]);
    return "";
};
const Root = () => {
    // Wrap the Index component in the withRouter call so we can use the history.listen event to listen for when the page changes, and
    // we can fire an event on the containing page so it can set the highlighted navigation section correctly.
    return (_jsxs(Router, { children: [_jsx(RouterListener, { onHistoryChange: (location) => {
                    Handlers.forEach((handler) => handler(location));
                } }), _jsx(LastLocationProvider, { children: _jsx(VirtualizedAppContextProvider, { children: _jsx(FolderStateContextProvider, { children: _jsx(NoticeContextProvider, { children: _jsx(InstitutionContextProvider, { children: _jsx(Index, {}) }) }) }) }) })] }));
};
// Expose ReactDOM, React, and components we want to instantiate directly from the outside.
window.React = React;
// We are currently using ReactDOM.render for rendering the GrapesJS link editor modal that will be deprecated when upgrading to React 18
window.ReactDOM = ReactDOM;
// @ts-expect-error - TS2339 - Property 'Root' does not exist on type 'Window & typeof globalThis'.
window.Root = Root;
// @ts-expect-error - TS2339 - Property 'AlertCoordinatorAdd' does not exist on type 'Window & typeof globalThis'.
window.AlertCoordinatorAdd = AlertCoordinatorAdd;
// @ts-expect-error - TS2339 - Property 'AlertCoordinatorsList' does not exist on type 'Window & typeof globalThis'.
window.AlertCoordinatorsList = AlertCoordinatorsList;
// @ts-expect-error - TS2339 - Property 'AlertEmailPreview' does not exist on type 'Window & typeof globalThis'.
window.AlertEmailPreview = AlertEmailPreview;
// @ts-expect-error - TS2339 - Property 'AchievementEmailPreview' does not exist on type 'Window & typeof globalThis'.
window.AchievementEmailPreview = AchievementEmailPreview;
// @ts-expect-error - TS2339 - Property 'AlertRuleAdd' does not exist on type 'Window & typeof globalThis'.
window.AlertRuleAdd = AlertRuleAdd;
// @ts-expect-error - TS2339 - Property 'AlertRulesList' does not exist on type 'Window & typeof globalThis'.
window.AlertRulesList = AlertRulesList;
// @ts-expect-error - TS2339 - Property 'EarlyAlertController' does not exist on type 'Window & typeof globalThis'.
window.EarlyAlertController = EarlyAlertController;
// @ts-expect-error - TS2339 - Property 'CourseLookupModal' does not exist on type 'Window & typeof globalThis'.
window.CourseLookupModal = CourseMultiSearchWrapper;
const root = document.getElementById("aviso_react_content");
if (root) {
    ReactDOM.render(React.createElement(Root), root);
}
